import {
  BrowserRouter as Router,
  Route,
  Routes,
  Navigate,
} from 'react-router-dom';
import CataloguePage from './pages/Catalogue';

import theme from './globals/theme/theme';
import { ThemeProvider, CssBaseline } from '@mui/material';
import { ToastContainer } from 'react-toastify';
import Authentication from './pages/Authentication';
import 'react-toastify/dist/ReactToastify.css';
import { useUser } from './components/AuthContext';
import PrivateRoute from './components/PrivateRoute';
import NotFoundPage from './pages/NotFound';
import Terms from './pages/Terms';
import ReusableModal from './components/Custom/Modal';
import './App.css';

function App() {
  const { isAuthenticated } = useUser();
  return (
    <ThemeProvider theme={theme}>
      <ReusableModal />
      <Router>
        <CssBaseline />
        <ToastContainer />
        <Routes>
          <Route
            path="/"
            element={
              isAuthenticated ? (
                <Navigate to="/catalogue" replace={true} />
              ) : (
                <Navigate to="/sign-in" replace={true} />
              )
            }
          />

          <Route path="/catalogue" element={<PrivateRoute />}>
            <Route index element={<CataloguePage />} />
          </Route>
          <Route path="/sign-in" element={<Authentication />} />
          <Route path="/terms" element={<Terms />} />
          <Route path="*" element={<NotFoundPage />} />
        </Routes>
      </Router>
    </ThemeProvider>
  );
}

export default App;
